import NoMatchFoundIcon from "assets/icons/NoMatchFoundIcon";
import CheckIcon from "assets/icons/CheckIcon";
import { QueryModalFilterOption } from "types";
import classNames from "classnames";
import AutoSizer from "react-virtualized-auto-sizer";
import { VariableSizeList as List } from "react-window";

import styles from "./style.module.scss";
import { ReactNode } from "react";

interface OptionProps {
  id: string;
  value: ReactNode;
  count?: string;
  selected?: boolean;
  showCheckBox: boolean;
  onSelect: (id: string) => void;
}

function Option({
  id,
  value,
  count = "",
  showCheckBox,
  selected = false,
  onSelect,
}: OptionProps) {
  const optionClassnames = classNames(styles.option, {
    [styles.checkBoxCountOption]: showCheckBox && count,
    [styles.countOption]: count && !showCheckBox,
    [styles.checkBoxOption]: showCheckBox && !count,
    [styles.selectedOption]: selected,
  });

  const checkBoxClassnames = classNames(styles.checkBox, {
    [styles.selectedCheckBox]: selected,
  });

  return (
    <div className={optionClassnames} onClick={() => onSelect(id)}>
      {showCheckBox && (
        <div className={checkBoxClassnames}>
          {selected && <CheckIcon variant="flat" />}
        </div>
      )}
      <span className={classNames(styles.optionText, "dropdownOptionText")}>
        {value}
      </span>

      {count && <span className={styles.count}>{count}</span>}
    </div>
  );
}

interface OptionsDropdownProps {
  selected: string[];
  multiSelect?: boolean;
  options: QueryModalFilterOption[];
  onSelect: (id: string) => void;
  itemHeight?: number;
}

const DEFAULT_ITEM_HEIGHT = 34;

export default function OptionsDropdown({
  options,
  selected,
  multiSelect = false,
  onSelect,
  itemHeight = DEFAULT_ITEM_HEIGHT,
}: OptionsDropdownProps) {
  return (
    <div
      className={styles.dropdownWrapper}
      data-testid="query-modal-options-dropdown"
    >
      {options.length > 0 ? (
        <AutoSizer>
          {({ width }: any) => (
            <List
              height={Math.min(240, options.length * itemHeight + 2)}
              width={width}
              itemCount={options.length}
              itemSize={() => itemHeight}
              className={classNames(styles.dropdown, {
                [styles.noOverflow]: options.length < 240 / itemHeight,
              })}
            >
              {({ index, style }) => {
                const option = options[index];
                const isSelected = selected.includes(option.id);
                return (
                  <div style={style}>
                    <Option
                      {...option}
                      value={option.element || option.text}
                      showCheckBox={multiSelect}
                      selected={isSelected}
                      onSelect={onSelect}
                    />
                  </div>
                );
              }}
            </List>
          )}
        </AutoSizer>
      ) : (
        <div className={styles.noResult}>
          <NoMatchFoundIcon />

          <span>
            No matches found
            <br />
            please try another term
          </span>
        </div>
      )}
    </div>
  );
}
